/**
 * Decode JWT token to extract payload data
 * @param {string} token JWT token
 * @returns {object} Decoded payload
 */
export const decodeJWT = (token) => {
  try {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    )
    return JSON.parse(jsonPayload)
  } catch (error) {
    console.error('Error decoding JWT:', error)
    return null
  }
}

/**
 * Extract user info from JWT token
 * @param {string} token JWT token
 * @returns {object|null} User info with email, role, permissions, etc.
 */
export const extractUserFromToken = (token) => {
  const decoded = decodeJWT(token)
  if (!decoded || !decoded.data) return null

  const { data } = decoded
  return {
    email: data.email,
    role: data.role,
    permissions: data.permissions || [],
    vendor_code: data.vendor_code,
    user_id: data.user_id,
    username: data.username,
    type: data.type,
  }
}
